import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Home from "./components/Home";
import Doctors from "./components/Doctors";
import Gallery from './components/Gallery';
import PriceList from './components/PriceList';
import Device from './components/Device';
import Devices from './components/Devices';
import Services from './components/Services';
import Contact from './components/Contact'

class Router extends Component {
  render() {
    const { devices, services, doctors } = this.props.data;

    return (
      <Switch>
        <Route exact path='/' component={Home} />
        <Route exact path='/doktori' render={props => <Doctors {...props} doctors={doctors} />} />
        <Route path='/doktori/:doctor' render={props => <Doctors {...props} doctors={doctors} />} />
        <Route exact path='/usluge' render={props => <Services {...props} services={services} />} />
        <Route path='/usluge/:service' render={props => <Services {...props} services={services} />} />
        <Route exact path='/aparati' render={props => <Devices {...props} devices={devices} />} />
        <Route path='/aparati/:device' render={props => <Device {...props} devices={devices} />} />
        <Route path='/galerija' component={Gallery} />
        {/* <Route path='/cenovnik' component={PriceList} /> */}
        <Route path='/kontakt' component={Contact} />
      </Switch>
    );
  }
}

export default Router;



// WEBPACK FOOTER //
// ./src/Router.js